import React from 'react';
class PWAThumbNail extends React.Component {
  state = {
    loading: false,
    thumb: undefined,
    originalName: undefined,
  };
  componentDidMount() {
    if (!this.props.file) {
      return;
    }
    this.setState({ originalName: this.props.file.originalName });
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.file) {
      return;
    }

    this.setState({ originalName: nextProps.file.originalName });
  }

  render() {
    const { file, s3Url } = this.props;
    const { loading, thumb } = this.state;
    if (loading) {
      return <p>loading...</p>;
    }

    if (!file) {
      return <span>{this.state.originalName}</span>;
    }

    return (
      <img
        className="img-150 img-thumbnail rounded img-fluid mx-auto d-block"
        src={file ? `${s3Url}${file.key}` : ''}
        alt={file.originalName}
        title={file.originalName}
      />
    );
  }
}

export default PWAThumbNail;
